import { ObjectiveStatus, KeyResultInput, ObjectiveDto, NoteInfoInput, ObjectiveInput } from '../../../types'
import { Moment } from 'moment-timezone'

type DateManipulation = {
  calcStartOfNextNYear: (param: number) => Moment
  calcEndOfNextNYear: (param: number) => Moment
}

export const newObjective = (isManagerPreparation: boolean, dateFunctions: DateManipulation): ObjectiveInput =>
  ({
    id: undefined,
    title: '',
    start: dateFunctions.calcStartOfNextNYear(0).toISOString(),
    due: dateFunctions.calcEndOfNextNYear(0).toISOString(),
    status: isManagerPreparation ? ObjectiveStatus.ProposalFromManager : ObjectiveStatus.Proposal,
    targetAmount: null,
    keyResults: [] as KeyResultInput[],
    noteList: [] as NoteInfoInput[],
  } as ObjectiveInput)

const filterOutTargetAmountGreaterThanZeroOrUndefined = (amount: number | null | undefined): boolean => {
  if (amount === undefined || amount === null) {
    return false
  }
  return amount > 0
}

export const filterObjectivesByTypeStatusAndRefYear = (
  objectives: ObjectiveDto[],
  isMonetary: boolean,
  statuses?: ObjectiveStatus[],
  referenceYear?: number,
): ObjectiveDto[] => {
  let filteredObjectives: ObjectiveDto[] = []

  if (isMonetary) {
    filteredObjectives = objectives.filter((o) => filterOutTargetAmountGreaterThanZeroOrUndefined(o.targetAmount))
  } else {
    filteredObjectives = objectives.filter((o) => !filterOutTargetAmountGreaterThanZeroOrUndefined(o.targetAmount))
  }

  if (statuses) {
    filteredObjectives = filterObjectiveDtoListByStatus(filteredObjectives, statuses)
  }

  if (referenceYear) {
    filteredObjectives = filterObjectivesByReferenceYear(filteredObjectives, referenceYear)
  }

  return filteredObjectives
}

export const filterObjectivesByTypeStatusAndRefYears = (
  objectives: ObjectiveDto[],
  isMonetary: boolean,
  statuses?: ObjectiveStatus[],
  referenceYears?: number[],
): ObjectiveDto[] => {
  let filteredObjectives: ObjectiveDto[] = []

  if (isMonetary) {
    filteredObjectives = objectives.filter((o) => filterOutTargetAmountGreaterThanZeroOrUndefined(o.targetAmount))
  } else {
    filteredObjectives = objectives.filter((o) => !filterOutTargetAmountGreaterThanZeroOrUndefined(o.targetAmount))
  }

  if (statuses) {
    filteredObjectives = filterObjectiveDtoListByStatus(filteredObjectives, statuses)
  }

  if (referenceYears && referenceYears.length > 0) {
    filteredObjectives = filterObjectivesByReferenceYears(filteredObjectives, referenceYears)
  }

  return filteredObjectives
}

export const filterObjectiveDtoListByStatus = (objectives: ObjectiveDto[], statuses: ObjectiveStatus[]): ObjectiveDto[] => {
  return objectives.filter((o) => statuses.some((status) => o.status === status))
}

export const filterObjectivesByReferenceYear = (objectives: ObjectiveDto[], referenceYear: number): ObjectiveDto[] => {
  return objectives.filter((objective) => objective.appraisalSeason.year === referenceYear)
}

const filterObjectivesByReferenceYears = (objectives: ObjectiveDto[], referenceYears: number[]): ObjectiveDto[] => {
  return objectives.filter((objective) => referenceYears.includes(objective.appraisalSeason.year))
}

export const filterObjectivesByStatusAndReferenceYear = (
  objectives: ObjectiveDto[],
  statuses: ObjectiveStatus[],
  referenceYear?: number,
): ObjectiveDto[] => {
  let filteredObjectives: ObjectiveDto[] = [...objectives]

  if (statuses) {
    filteredObjectives = filterObjectiveDtoListByStatus(filteredObjectives, statuses)
  }

  if (referenceYear) {
    filteredObjectives = filterObjectivesByReferenceYear(filteredObjectives, referenceYear)
  }

  return filteredObjectives
}
